var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientAssest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Grupo_8734",
    width: 54.21,
    height: 33.248,
    "data-name": "Grupo 8734",
    viewBox: "0 0 54.21 33.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-3{fill:#09c}.cls-2{stroke:#09c}.cls-3{stroke:#19c}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3021",
    "data-name": "Grupo 3021",
    transform: "translate(4.105)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_185",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    className: "cls-1",
    "data-name": "Elipse 185",
    transform: "translate(5.458 17.944)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_186",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    className: "cls-1",
    "data-name": "Elipse 186",
    transform: "translate(9.128 17.944)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_187",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    className: "cls-1",
    "data-name": "Elipse 187",
    transform: "translate(12.631 17.944)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_188",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    className: "cls-1",
    "data-name": "Elipse 188",
    transform: "translate(16.329 17.944)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3020",
    "data-name": "Grupo 3020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3013",
    "data-name": "Grupo 3013",
    transform: "translate(0 15.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23085",
    d: "M-415.977-73.948h-23.537v-17.934h23.537zm-22.07-1.467h20.6v-15h-20.6z",
    className: "cls-1",
    "data-name": "Trazado 23085",
    transform: "translate(439.514 91.882)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3014",
    "data-name": "Grupo 3014",
    transform: "translate(.734 21.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_3451",
    d: "M0 0h22.07v1.467H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 3451"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3015",
    "data-name": "Grupo 3015",
    transform: "translate(5.458 23.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_3452",
    d: "M0 0h13.487v1.467H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 3452"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3016",
    "data-name": "Grupo 3016",
    transform: "translate(34.795 5.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_3453",
    d: "M0 0h1.467v2.652H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 3453",
    transform: "rotate(-1.516 1.474 .02)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3017",
    "data-name": "Grupo 3017",
    transform: "translate(34.831 17.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_3454",
    d: "M0 0h1.467v3.933H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 3454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3018",
    "data-name": "Grupo 3018",
    transform: "translate(22.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23086",
    d: "M-406.552-69.085h-17.915V-102.3h17.915zM-423-70.552h14.981v-30.282H-423z",
    className: "cls-1",
    "data-name": "Trazado 23086",
    transform: "translate(424.467 102.301)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3019",
    "data-name": "Grupo 3019",
    transform: "translate(22.804 11.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_3455",
    d: "M0 0h16.448v1.467H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 3455"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24399",
    d: "M0 0h48.243",
    className: "cls-3",
    "data-name": "Trazado 24399",
    transform: "translate(0 32.748)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientAssest);
export default __webpack_public_path__ + "static/media/client-assest.a26e5ec9fcc5eb9658646a60af9c851c.svg";
export { ForwardRef as ReactComponent };